/**
 * Created by liuyong on 2021/4/14
 */
import { mul } from '@/utils/decimal'
import dayjs from 'dayjs'

const getDeviceRatio = () => {
  let isIPhone = window.navigator.appVersion.match(/iphone/gi)
  let devicePixelRatio = window.devicePixelRatio
  let dpr
  if (isIPhone) {
    // iOS下，对于2和3的屏，用2倍的方案，其余的用1倍方案
    if (devicePixelRatio >= 3) {
      dpr = 3
    } else if (devicePixelRatio >= 2) {
      dpr = 2
    } else {
      dpr = 1
    }
  } else {
    // 其他设备下，仍旧使用1倍的方案
    dpr = 1
  }
  return dpr
}

const DEVICE_RATIO = getDeviceRatio()

// 下拉配置
export const DOWN_CONFIG = {
  threshold: 50 * DEVICE_RATIO,
  stop: 20 * DEVICE_RATIO
}
// 上拉配置
export const UP_CONFIG = {
  threshold: -40 * DEVICE_RATIO
}

// 计算金额
// money: 要改变的数字
// status: 使用 '+' 还是 '-'
// nums: 保留小数点后的位数
// isSymbol: 是否需要使用 '+''-' 号，默认是 true
export function calMoney(money, status, nums, isSymbol = true, isType = true) {
  if (money === 0) {
    return '0.00'
  }
  if (isSymbol) {
    if (status === 0) {
      return `+${mul(money, 0.01).toFixed(nums)}`
    } else {
      return `-${mul(money, 0.01).toFixed(nums)}`
    }
  } else {
    if (isType) {
      return mul(money, 0.01).toFixed(nums)
    } else {
      return mul(money, 100).toFixed(nums)
    }
  }
}

// 字符串截取
// number 截取的数字
// startIndex 开始下标
// endIndex 结束下标
export function substrString(number, startIndex, endIndex) {
  return String(number).substr(startIndex, endIndex)
}

// 保留小数点位数
export function setFixed(num, nums) {
  return Number(num).toFixed(nums)
}

// 获取主题颜色
const themeColor = {
  '#1677FE': function() {
    return 1
  },
  '#FF2550': function() {
    return 2
  },
  '#FF4B33': function() {
    return 3
  }
}

export function setThemeColor(type) {
  return themeColor[type]()
}

// 获取码状态
const cdkeyStatus = {
  '10': function() {
    return {
      code_status: '',
      code_text: ''
    }
  },
  '11': function() {
    return {
      code_status: '充值中',
      code_text: '充值高峰期略有延迟，到账时间以运营商为准'
    }
  },
  '12': function() {
    return {
      code_status: '兑换成功',
      code_text: '本服务合作方暂无法提供机打发票'
    }
  },
  '13': function() {
    return {
      code_status: '充值失败',
      code_text: ''
    }
  },
  '30': function() {
    return {
      code_status: '',
      code_text: ''
    }
  },
  '31': function() {
    return {
      code_status: '发货中',
      code_text: '发货高峰期略有延迟，到账时间以供货商为准'
    }
  },
  '32': function() {
    return {
      code_status: '兑换成功',
      code_text: '本服务合作方暂无法提供机打发票'
    }
  },
  '33': function() {
    return {
      code_status: '发货失败',
      code_text: ''
    }
  },
  '40': function() {
    return {
      code_status: '',
      code_text: ''
    }
  },
  '41': function() {
    return {
      code_status: '充值中',
      code_text: '充值高峰期略有延迟，到账时间以供货商为准'
    }
  },
  '42': function() {
    return {
      code_status: '兑换成功',
      code_text: '本服务合作方暂无法提供机打发票'
    }
  },
  '43': function() {
    return {
      code_status: '充值失败',
      code_text: '供货商充值失败，请重新选择'
    }
  },
  '70': function() {
    return {
      code_status: '',
      code_text: ''
    }
  },
  '71': function() {
    return {
      code_status: '充值中',
      code_text: '充值高峰期略有延迟，到账时间以供货商为准'
    }
  },
  '72': function() {
    return {
      code_status: '兑换成功',
      code_text: '本服务合作方暂无法提供机打发票'
    }
  },
  '73': function() {
    return {
      code_status: '充值失败',
      code_text: '供货商充值失败，请重新选择'
    }
  },
  '7-1': function() {
    return {
      code_status: '',
      code_text: ''
    }
  }
}

export function cdkeyStatusTree(type) {
  console.log(type)
  return cdkeyStatus[type]()
}

// 格式化时间
export function formatTime(time, format) {
  return dayjs(time).format(format)
}

// 判断正整数
// number 数字
export function isIntegerNumber(number) {
  return Number.isInteger(Number(number))
}

// 数字抹零
// number 数字
export function isParseFloat(number) {
  return parseFloat(Number(number))
}

export function isHttp(str) {
  if (str.slice(0, 7).toLowerCase() === 'http://') {
    return str
  } else {
    return `http://${str}`
  }
}

// 获取码状态
const couponStatus = {
  '10': function() {
    return {
      code_status: '',
      code_text: ''
    }
  },
  '11': function() {
    return {
      code_status: '充值中',
      code_text: '充值高峰期略有延迟，到账时间以运营商为准'
    }
  },
  '12': function() {
    return {
      code_status: '兑换成功',
      code_text: '本服务合作方宽商暂无法提供机打发票'
    }
  },
  '13': function() {
    return {
      code_status: '充值失败',
      code_text: ''
    }
  }
}

export function couponStatusTree(type) {
  return couponStatus[type]()
}

// money: 要改变的数字
// nums: 保留小数点后的位数
export function calNumberMoney(money, nums) {
  if (money === 0) {
    return '0.00'
  } else {
    // 判断数字是否有小数
    if (String(money).indexOf('.') !== -1) {
      return parseInt(String(money).substring(0, String(money).indexOf('.'))) / 100
    } else {
      return (String(money) / 100).toFixed(nums)
    }
  }
}
